export default "__VITE_ASSET__6NAVkXdK__"